import styled from 'styled-components';

export const ChatbotContainer = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

export const ChatButton = styled.button`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #04110A;
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #0FFE95;
    transform: scale(1.05);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

export const ChatWindow = styled.div`
  width: 350px;
  height: 500px;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transform: translateY(20px);
  opacity: 0;
  animation: fadeInUp 0.3s ease forwards;
  
  @keyframes fadeInUp {
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const ChatHeader = styled.div`
  background-color: #04110A;
  color: white;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ChatTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
`;

export const MessagesContainer = styled.div`
  flex: 1;
  padding: 16px;
  overflow-y: auto;
  background-color: #f9fafb;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const WelcomeMessage = styled.div`
  text-align: center;
  color: #6b7280;
  font-size: 14px;
  margin-top: auto;
  margin-bottom: auto;
  padding: 16px;
`;

export const Message = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ sender }) => (sender === 'user' ? 'flex-end' : 'flex-start')};
`;

export const MessageContent = styled.div`
  max-width: 80%;
  padding: 10px 14px;
  border-radius: ${({ sender }) => 
    sender === 'user' ? '12px 12px 0 12px' : '12px 12px 12px 0'};
  background-color: ${({ sender }) => 
    sender === 'user' ? '#04110A' : '#e5e7eb'};
  color: ${({ sender }) => 
    sender === 'user' ? 'white' : '#1f2937'};
  font-size: 14px;
  line-height: 1.4;
  word-wrap: break-word;
`;

export const MessageTime = styled.span`
  font-size: 10px;
  color: #6b7280;
  margin-top: 4px;
`;

export const InputContainer = styled.div`
  display: flex;
  padding: 12px;
  background-color: white;
  border-top: 1px solid #e5e7eb;
`;

export const MessageInput = styled.input`
  flex: 1;
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  outline: none;
  font-size: 14px;
  transition: border-color 0.2s;
  
  &:focus {
    border-color: #04110A;
  }
`;

export const SendButton = styled.button`
  margin-left: 8px;
  background-color: #04110A;
  color: white;
  border: none;
  border-radius: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #0FFE95;
  }
  
  &:disabled {
    background-color: #9ca3af;
    cursor: not-allowed;
  }
`;

export const LoadingMessageContent = styled.div`
  padding: 10px 14px;
  border-radius: 12px 12px 12px 0;
  background-color: #e5e7eb;
  color: #1f2937;
  font-size: 14px;
  line-height: 1.4;
`;

export const LoadingDots = styled.div`
  display: inline-flex;
  
  span {
    animation: dotPulse 1.5s infinite ease-in-out;
    opacity: 0;
    
    &:nth-child(1) {
      animation-delay: 0s;
    }
    
    &:nth-child(2) {
      animation-delay: 0.2s;
    }
    
    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }
  
  @keyframes dotPulse {
    0%, 100% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }
`;